<template>
    <v-container fluid grid-list-md>
        <v-layout row wrap justify-center>
            <v-flex xs10>
                <v-autocomplete
                        :items="users.items"
                        :loading="!users.loaded"
                        :disabled="!users.loaded || loading"
                        v-model="selectedUser"
                        return-object
                        :label="$t('user')"
                        item-text="selectText"
                        @input="fetchUser"
                >
                </v-autocomplete>
            </v-flex>
            <v-flex xs2>
                <v-btn color="red" flat block :disabled="!users.loaded || !fetchedUser || loading" @click="deleteUser">
                    {{ $t('delete') }}
                </v-btn>
            </v-flex>
            <v-flex xs12>
                <v-btn block :disabled="!users.loaded || !fetchedUser || loading" @click="switchUser">
                    Zu Institution wechseln
                </v-btn>
            </v-flex>
            <v-flex xs6 v-if="fetchedUser && !loading">
                <v-text-field
                    v-model="fetchedUser.balance"
                    label="Guthaben in Euro"
                    placeholder="Guthaben"
                    min="0"
                    type="number"
                    suffix="€"
                />
            </v-flex>
            <v-flex xs6 v-if="fetchedUser && !loading">
                <v-btn block :disabled="!users.loaded || !fetchedUser || loading" @click="saveBalance">
                    Guthaben speichern
                </v-btn>
            </v-flex>

            <v-flex xs12 v-if="fetchedUser && !loading">
                <v-card>
                    <v-card-title primary-title>
                        <h3 class="headline mb-0">Details</h3>
                    </v-card-title>
                    <v-card-text>
                        <h4>Kundennummer</h4>
                        {{ fetchedUser.sev_desk_id ? fetchedUser.sev_desk_id : 'Noch nicht erstellt' }}

                        <h4 v-show="fetchedUser.company">Firma</h4>
                        {{ fetchedUser.company }}

                        <h4>Vorname</h4>
                        {{ fetchedUser.first_name }}

                        <h4>Nachname</h4>
                        {{ fetchedUser.last_name }}

                        <h4>E-Mail</h4>
                        {{ fetchedUser.email }}

                        <h4 v-show="fetchedUser.street">Adresse</h4>
                        <span v-show="fetchedUser.street">{{ fetchedUser.street }} {{ fetchedUser.street_number }}</span><br>
                        <span v-show="fetchedUser.postcode || fetchedUser.town">{{ fetchedUser.postcode }} {{ fetchedUser.town }}</span>

                        <h4 v-show="fetchedUser.telephone">Telefon</h4>
                        <span v-show="fetchedUser.telephone">{{ fetchedUser.telephone }}</span>

                        <h4>Anzahl Tänzer</h4>
                        {{ fetchedUser.dancers_count }}

                        <h4>Anzahl Starter</h4>
                        {{ fetchedUser.starter_templates_count }}

                        <h4>Letzter Login</h4>
                        {{ fetchedUser.last_login ? $formatDate(fetchedUser.last_login) : 'noch nie im neuen Portal' }}
                    </v-card-text>
                </v-card>
            </v-flex>

            <v-progress-circular v-if="loading" indeterminate color="primary"></v-progress-circular>
        </v-layout>
    </v-container>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        data () {
            return {
                loading: false,
                fetchedUser: null,
                selectedUser: null
            }
        },
        computed: mapState(['users', 'user']),
        methods: {
            fetchUser() {
                if (!this.selectedUser) {
                    return;
                }

                this.loading = true;

                axios.get(`/api/v1/users/${this.selectedUser.id}`).then(response => {

                    if (!response.data.success) {
                        return;
                    }

                    this.fetchedUser = response.data.data;
                    if (this.fetchedUser.balance > 0) {
                        this.fetchedUser.balance = this.fetchedUser.balance/100
                    }

                    this.loading = false;
                }, errorResponse => {
                    console.log(errorResponse);
                    this.loading = false;
                });
            },
            switchUser() {
                if (!this.fetchedUser) {
                    return;
                }

                this.$store.commit('switchUser', this.fetchedUser);
                this.$store.commit('snackBar', {
                    color: 'success',
                    text: this.$t('user_switched', [this.selectedUser.selectText])
                });
            },
            deleteUser() {
                this.$store.commit('confirm', {
                    headline: 'Institution löschen',
                    text: this.$t('questions.remove', [this.fetchedUser.display_name]),
                    callback: () => {
                        this.loading = true;
                        let name = this.fetchedUser.display_name;
                        axios.delete(`/api/v1/users/${this.fetchedUser.id}`).then(response => {

                            if (!response.data.success) {
                                this.$store.commit('snackBar', {
                                    color: 'error',
                                    text: 'Fehler beim löschen'
                                });
                                return;
                            }

                            this.$store.commit('snackBar', {
                                color: 'success',
                                text: this.$t('was_deleted', [name])
                            });

                            this.fetchedUser = null;

                            this.$store.dispatch('loadUsers');

                            this.loading = false;

                        }, errorResponse => {
                            console.log(errorResponse);
                            this.$store.commit('snackBar', {
                                color: 'error',
                                text: 'Fehler beim löschen'
                            });
                            this.loading = false;
                        });
                    }
                });
            },
            saveBalance() {
                const balanceInCent = parseInt(parseFloat(this.fetchedUser.balance) * 100)
                console.log(balanceInCent)
                axios.post('/api/v1/users/balance', { balance: balanceInCent, user_id: this.fetchedUser.id })
                    .then(response => {
                        this.$store.commit('snackBar', {
                            color: 'success',
                            text: this.$t('Guthaben gespeichert')
                        });
                    }).catch(res => {
                        this.$store.commit('snackBar', {
                            color: 'error',
                            text: this.$t('Fehler beim Speichern')
                        });
                    })
            }
        }
    }
</script>
